import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { BUYER_GUIDE } from "../../data/km";

const Veil = () => (
  <div className="absolute inset-x-0 bottom-0 h-[48%] pointer-events-none" aria-hidden="true">
    <div className="absolute inset-0 backdrop-blur-[5px] [mask-image:linear-gradient(to_bottom,transparent,black_45%)] [-webkit-mask-image:linear-gradient(to_bottom,transparent,black_45%)]" />
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/40 to-white/90" />
  </div>
);

const Page = ({ p, className = "" }) => (
  <div className={`relative aspect-[935/1210] overflow-hidden bg-white ${className}`}>
    <img src={p.src} alt={`Buyer's Blueprint preview: ${p.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
    <Veil />
  </div>
);

export default function BlueprintPeek() {
  const [active, setActive] = useState(null);
  const toForm = () => {
    setActive(null);
    setTimeout(() => document.getElementById("guide-signup")?.scrollIntoView({ behavior: "smooth", block: "center" }), 250);
  };
  return (
    <section className="px-6 md:px-12 lg:px-16 pb-16 md:pb-24 lg:pb-28 bg-[#F4F3EF]" data-testid="blueprint-peek">
      <div className="max-w-[1180px] mx-auto">
        <p className="km-eyebrow text-[10px] lg:text-[12px] mb-3 text-[#2C4A3B]">A Look Inside</p>
        <h2 className="km-serif text-[30px] sm:text-[40px] lg:text-[48px] leading-[1.05] text-[#141414] mb-6 md:mb-10">Sneak <em>peek.</em></h2>
        <div className="-mx-6 px-6 md:mx-0 md:px-0 flex md:grid md:grid-cols-4 gap-4 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-px-6 md:scroll-px-0 pb-3 [scrollbar-width:none]">
          {BUYER_GUIDE.peek.map((p, i) => (
            <button key={p.title} onClick={() => setActive(p)} className="group text-left shrink-0 w-[62%] sm:w-[40%] md:w-auto snap-start" data-testid={`peek-page-${i}`}>
              <Page p={p} className="shadow-[0_20px_40px_-22px_rgba(0,0,0,0.45)] transition-transform duration-500 group-hover:-translate-y-1" />
              <p className="km-eyebrow text-[10px] text-[#141414] mt-3">{p.title}</p>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(v) => !v && setActive(null)}>
        <DialogContent className="w-[calc(100vw-1.5rem)] max-w-[560px] max-h-[94svh] overflow-y-auto rounded-none p-4 sm:p-6 gap-3 bg-white" data-testid="peek-dialog">
          <DialogTitle className="km-eyebrow text-[10px] font-normal text-[#2C4A3B]">{active?.title}</DialogTitle>
          <DialogDescription className="sr-only">Preview page from the Buyer's Blueprint</DialogDescription>
          {active && <Page p={active} className="w-full mx-auto max-w-[calc((90svh-140px)*0.7727)]" />}
          <button onClick={toForm} className="km-btn-dark gap-2 w-full" data-testid="peek-unlock"><Lock size={13} strokeWidth={1.5} /> Get the Full Blueprint</button>
        </DialogContent>
      </Dialog>
    </section>
  );
}
